import api from "../axios";
import type { Scope } from "../types";

export class ApiToken {
  addToken(token: string) {
    return api.post<{ supplier_id: string; granted_role?: string | null }>(
      "/tokens",
      { token },
    );
  }

  getTokenScopes() {
    return api.get<{ data: Scope[] }>("/tokens/scopes");
  }
}
